import Carousels from "../components/Carousels";
// import banner1 from "../assets/images/banner/banner1.jpg";
import banner2 from "../assets/images/banner/banner2.jpg";
import banner3 from "../assets/images/banner/banner3.jpg";
// import banner4 from "../assets/images/banner/banner4.jpg";
import banner5 from "../assets/images/banner/banner5.jpg";
import banner6 from "../assets/images/banner/banner6.jpg";
import banner7 from "../assets/images/banner/banner7.jpg";
import banner8 from "../assets/images/banner/banner8.jpg";
import banner9 from "../assets/images/banner/banner9.jpg";
import banner10 from "../assets/images/banner/banner10.jpg";
// import banner11 from "../assets/images/banner/banner11.jpg";
import banner12 from "../assets/images/banner/banner12.jpg";
import banner13 from "../assets/images/banner/banner13.jpg";
import banner14 from "../assets/images/banner/banner14.jpg";
import About from "../components/homeComponents/About";
import ImportantLinks from "../components/homeComponents/ImportantLinks";
import MultiCarousel from "../components/homeComponents/multiCarousel";
import { useState } from "react";
import Testimonials from "../components/homeComponents/Testimonials";

export const homeImages = [banner13,banner14, banner2, banner3,  banner5, banner6, banner7, banner8, banner9, banner10, banner12];

type Props = {};

const Home = (props: Props) => {
  return (
    <div>
      <Carousels {...homeImages} />
      <About/>
      {/* <ImportantLinks /> */}
      <MultiCarousel />
      <Testimonials/>
    </div>
  );
};

export default Home;
